export const GRANT_ACCESS_PATH = '/grant-access/private';
export const RESOLVE_ACCESS_PATH = '/share-link/private';
export const LINK_ERROR_PATH = '/share-link/error';
export const PUBLIC_LINK_PATH = '/share-link/public';
